// extracted by mini-css-extract-plugin
export default {"filmsView":"FilmsView_filmsView__HYcp+"};